var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUspStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lucide/star",
    clipPath: "url(#clip0_0_315)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.76297 1.15462C5.78488 1.1082 5.81873 1.06912 5.86069 1.0418C5.90265 1.01448 5.95106 1 6.00045 1C6.04984 1 6.09825 1.01448 6.14021 1.0418C6.18217 1.06912 6.21602 1.1082 6.23793 1.15462L7.39282 3.60795C7.46891 3.76942 7.58121 3.90912 7.72011 4.01506C7.859 4.121 8.02033 4.19001 8.19025 4.21617L10.773 4.61256C10.822 4.61999 10.8679 4.64164 10.9058 4.67506C10.9436 4.70847 10.9717 4.75232 10.987 4.80163C11.0023 4.85095 11.0041 4.90377 10.9923 4.95412C10.9805 5.00447 10.9554 5.05035 10.92 5.08655L9.05217 6.99405C8.92899 7.11994 8.83683 7.27534 8.78362 7.44688C8.7304 7.61841 8.71773 7.80093 8.7467 7.97874L9.18766 10.6738C9.1963 10.7251 9.19102 10.7779 9.17241 10.8262C9.15381 10.8745 9.12263 10.9163 9.08244 10.947C9.04225 10.9776 8.99467 10.9957 8.94512 10.9993C8.89556 11.0029 8.84604 10.9919 8.8022 10.9674L6.4934 9.69433C6.34128 9.61056 6.17202 9.56679 6.0002 9.56679C5.82837 9.56679 5.65912 9.61056 5.50699 9.69433L3.1987 10.9674C3.15487 10.9917 3.10541 11.0027 3.05594 10.999C3.00647 10.9953 2.95898 10.9771 2.91887 10.9465C2.87877 10.916 2.84765 10.8742 2.82906 10.8259C2.81048 10.7777 2.80517 10.725 2.81374 10.6738L3.2542 7.97926C3.28329 7.80137 3.27069 7.61873 3.21747 7.44709C3.16425 7.27545 3.07202 7.11997 2.94872 6.99405L1.08089 5.08707C1.04519 5.05091 1.01989 5.00496 1.00788 4.95446C0.995866 4.90395 0.997619 4.85093 1.01294 4.80142C1.02826 4.7519 1.05653 4.7079 1.09453 4.67442C1.13253 4.64094 1.17874 4.61932 1.22788 4.61203L3.81015 4.21617C3.98026 4.19021 4.14181 4.12129 4.2809 4.01534C4.41998 3.90939 4.53243 3.76958 4.60857 3.60795L5.76297 1.15462Z",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUspStar);
export default __webpack_public_path__ + "static/media/usp-star.fb231dbc043f67f4b44bf962b06a3f79.svg";
export { ForwardRef as ReactComponent };